import './Header.css';
import { Link } from 'react-router-dom';
import logo from '../../../../assets/edunexus.png';
import Button from '../../../../components/Button/Button';
import { ButtonProps } from '../../../../types';

function Header() {
    const hamburguerProps: ButtonProps = {
        id: "mobile-menu-button",
        name: "☰",
        type: "button",
        props: {
            popoverTarget: "mobile-menu",
            className: "mobile-menu-button"
        }
    }

    return (
        <header id="auth-header">
            <nav className="container">
                <div className="logo">
                    <Link to="/" className="link">
                        <img src={logo} alt="Logo" />
                    </Link>
                </div>

                <div className="itens">
                    <Link to="/" className="link">Home</Link>
                    <Link to="/courses" className="link">Courses</Link>
                    <Link to="/about-us" className="link">About Us</Link>
                    <Link to="/contact" className="link">Contact</Link>
                    <Link to="/login" className="link">
                        <Button id="login" name="Login" />
                    </Link>
                </div>
            </nav>

            <div className="mobile-menu-container">
                <div className="logo">
                    <img src={logo} alt="Logo" />
                </div>

                <button className="avatar mobile-menu-button" id="mobile-menu-button" popoverTarget="mobile-menu">
                    GV
                </button>

                <dialog popover="auto" id={hamburguerProps.props.popoverTarget} className="menu">
                    <Link to="/" className="link">Home</Link>
                    <Link to="/courses" className="link">Courses</Link>
                    <Link to="/about-us" className="link">About Us</Link>
                    <Link to="/contact" className="link">Contact</Link>

                    <hr className="divider" />

                    <Link to="/login" className="link">
                        <Button id="login" name="Login" />
                    </Link>
                </dialog>
            </div>
        </header>
    );
}

export default Header;